import { VideoPlayer } from './video-player.interface';

declare global {
    interface Window {
        YT: any;
        onYouTubeIframeAPIReady: () => void;
    }
}

function extractYouTubeId(url: string): string {
    const m = url.match(/(?:v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    return m ? m[1] : '';
}

function loadYouTubeApi(): Promise<void> {
    if (window.YT && window.YT.Player) return Promise.resolve();
    return new Promise((resolve) => {
        window.onYouTubeIframeAPIReady = resolve;
        if (!document.getElementById('yt-iframe-api')) {
            const s = document.createElement('script');
            s.id = 'yt-iframe-api';
            s.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(s);
        }
    });
}

export class YouTubeVideoPlayer implements VideoPlayer {
    private player: any;
    private playCb: () => void;
    private pauseCb: () => void;
    private endedCb: () => void;

    async load(container: HTMLElement, url: string, startPosition: number): Promise<void> {
        await loadYouTubeApi();
        const videoId = extractYouTubeId(url);

        await new Promise<void>((resolve) => {
            this.player = new window.YT.Player(container, {
                videoId,
                playerVars: { start: Math.floor(startPosition), rel: 0 },
                events: {
                    onReady: () => resolve(),
                    onStateChange: (e: any) => this.onStateChange(e),
                },
            });
        });
    }

    private onStateChange(e: any): void {
        const state = e.data;
        if (state === window.YT.PlayerState.PLAYING && this.playCb) this.playCb();
        if (state === window.YT.PlayerState.PAUSED && this.pauseCb) this.pauseCb();
        if (state === window.YT.PlayerState.ENDED && this.endedCb) this.endedCb();
    }

    async getPosition(): Promise<number> {
        return this.player?.getCurrentTime() ?? 0;
    }

    async pause(): Promise<void> {
        this.player?.pauseVideo();
    }

    destroy(): void {
        this.player?.destroy();
    }

    onPlay(cb: () => void): void { this.playCb = cb; }
    onPause(cb: () => void): void { this.pauseCb = cb; }
    onEnded(cb: () => void): void { this.endedCb = cb; }
}
